"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSexualOrientation = exports.UserRace = exports.UserMilitaryStatus = exports.UserGenderIdentity = exports.UsageDuration = exports.UploadType = exports.SleepDiaryEntryTimeOfDay = exports.SleepDiaryEntryDuration = exports.SessionState = exports.RoleType = exports.RatingType = exports.RatingDuration = exports.QuizSetItemType = exports.PtsdDosageVersion = exports.ProductVersion = exports.ProductVariant = exports.PracticeType = exports.PatientSupporterRelation = exports.PatientSexualOrientation = exports.PatientRace = exports.PatientMilitaryStatus = exports.PatientGenderIdentity = exports.OuiUserRoleType = exports.OnboardingVariant = exports.MuxFitMode = exports.MediaAction = exports.LegacyUserSexuality = exports.LegacyUserRace = exports.LegacyUserGender = exports.JobType = exports.JobStatus = exports.FileUploadType = exports.ErrorStatus = exports.ErrorMessage = exports.EntityType = exports.EatingProgressWeightUnit = exports.EatingLogMealType = exports.EatingCommitmentUnhealthyFood = exports.EatingCommitmentHealthyFood = exports.EatingCheckinTrigger = exports.EatingCheckinCompletionButton = exports.CrisisFramework = exports.ContentType = exports.ContactPointUse = exports.ContactPointSystem = exports.CompositionTemplate = exports.CaringContactsMedium = exports.AppActivityName = exports.AddressUse = exports.ActionType = void 0;
exports.PracticeTypeSchema = exports.PatientSupporterRelationSchema = exports.PatientSexualOrientationSchema = exports.PatientRaceSchema = exports.PatientMilitaryStatusSchema = exports.PatientGenderIdentitySchema = exports.OuiUserRoleTypeSchema = exports.OnboardingVariantSchema = exports.MuxFitModeSchema = exports.MediaActionSchema = exports.LegacyUserSexualitySchema = exports.LegacyUserRaceSchema = exports.LegacyUserGenderSchema = exports.JobTypeSchema = exports.JobStatusSchema = exports.FileUploadTypeSchema = exports.ErrorStatusSchema = exports.ErrorMessageSchema = exports.EntityTypeSchema = exports.EatingProgressWeightUnitSchema = exports.EatingLogMealTypeSchema = exports.EatingCommitmentUnhealthyFoodSchema = exports.EatingCommitmentHealthyFoodSchema = exports.EatingCheckinTriggerSchema = exports.EatingCheckinCompletionButtonSchema = exports.CrisisFrameworkSchema = exports.ContentTypeSchema = exports.ContactPointUseSchema = exports.ContactPointSystemSchema = exports.CompositionTemplateSchema = exports.CaringContactsMediumSchema = exports.AppActivityNameSchema = exports.AddressUseSchema = exports.ActionTypeSchema = exports.YstRecurringAvailabilitySchema = exports.YstOnboardingAvailabilitySchema = exports.YstMentalHealthConcernsSchema = exports.UserIDSchema = exports.UUIDSchema = exports.QuizSetItemQuestionLabelSchema = exports.QuizSetItemQuestionDirectiveFeedbackSchema = exports.MapSchema = exports.JSONObjectSchema = exports.DateTimeSchema = exports.DateSchema = exports.AssetIDSchema = exports.ArtifactIDSchema = exports.AnySchema = exports.YstPatientMessageValue = exports.YstNominationStatusValue = void 0;
exports.DeviceInputSchema = exports.DeleteSessionInputSchema = exports.DeleteSessionGroupInputSchema = exports.CreateUserInputSchema = exports.CreateRoleInputSchema = exports.CopySessionInputDestinationSchema = exports.CopySessionInputSchema = exports.CopyQuizSetToCollectionInputSchema = exports.ContactPointInputSchema = exports.CompletedQuizSetsForPatientInputSchema = exports.CompleteQuizSetForPatientInputSchema = exports.ChangeBiteRoleSettingsInputSchema = exports.CMSVariantUpdateInputSchema = exports.CMSVariantCreateInputSchema = exports.CMSSessionGroupUpdateInputSchema = exports.CMSSessionGroupCreateInputSchema = exports.CMSSessionCreateInputSchema = exports.CMSAppUpdateInputSchema = exports.CMSAppCreateInputSchema = exports.BreathHoldingWidgetStressBreathingExercisesInputSchema = exports.AddressInputSchema = exports.AddThoughtDiaryEntryPracticeInputSchema = exports.AddSleepDiaryEntryPracticeInputSchema = exports.AddRelaxDiaryEntryPracticeInputSchema = exports.AddHopeKitVideoInputSchema = exports.AddHopeKitQuoteInputSchema = exports.AddHopeKitImageInputSchema = exports.AddEatingLogEntryInputSchema = exports.AddActivityPracticeInputSchema = exports.AddActionInputSchema = exports.ActivityInputSchema = exports.ActionValuesInputSchema = exports.YstPatientMessageValueSchema = exports.YstNominationStatusValueSchema = exports.UserSexualOrientationSchema = exports.UserRaceSchema = exports.UserMilitaryStatusSchema = exports.UserGenderIdentitySchema = exports.UsageDurationSchema = exports.UploadTypeSchema = exports.SleepDiaryEntryTimeOfDaySchema = exports.SleepDiaryEntryDurationSchema = exports.SessionStateSchema = exports.RoleTypeSchema = exports.RatingTypeSchema = exports.RatingDurationSchema = exports.QuizSetItemTypeSchema = exports.PtsdDosageVersionSchema = exports.ProductVersionSchema = exports.ProductVariantSchema = void 0;
exports.OrganizationInputSchema = exports.OrganizationAvivaConfigInputSchema = exports.MutationUpdateYstSupporterEventInputSchema = exports.MutationUpdateYstMentalHealthConcernsInputSchema = exports.MutationUpdateWordPairingPracticeInputSchema = exports.MutationUpdateUserInputSchema = exports.MutationUpdateRoleSettingsInputSchema = exports.MutationUpdateRecurringAvailabilityInputSchema = exports.MutationUpdatePracticeInputSchema = exports.MutationUpdateOnboardingAvailabilityInputSchema = exports.MutationUpdateHyperventilationPracticeInputSchema = exports.MutationUpdateFirstCheckinDateInputSchema = exports.MutationUpdateEatingProgressEntryInputSchema = exports.MutationUpdateEatingCheckinInputSchema = exports.MutationUpdateBreathHoldingPracticeInputSchema = exports.MutationSignupYSTYouthInputSchema = exports.MutationSignupYSTGuardianInputSchema = exports.MutationResendYstPatientMessageInputSchema = exports.MutationRateYstSupporterCheckinInputSchema = exports.MutationPreviewYstPatientMessageInputSchema = exports.MutationPersistBotStateInputSchema = exports.MutationNominateYstSupportersInputSchema = exports.MutationInviteYSTYouthInputSchema = exports.MutationInviteYSTGuardianInputSchema = exports.MutationDeclineYstNominationInputSchema = exports.MutationCreateVideoInputSchema = exports.MutationCreateUserInputSchema = exports.MutationCreateTestScenarioInputSchema = exports.MutationCreateJobInputSchema = exports.MutationContactYstSupportInputSchema = exports.MutationAddYstSupporterEventInputSchema = exports.MutationAddWordPairingPracticeInputSchema = exports.MutationAddHyperventilationPracticeInputSchema = exports.MutationAddEatingProgressEntryInputSchema = exports.MutationAddEatingCheckinInputSchema = exports.MutationAddBreathHoldingPracticeInputSchema = exports.LatLngInputSchema = exports.HyperventilationWidgetStressBreathingExercisesInputSchema = exports.HopeKitVideoInputSchema = exports.HopeKitQuoteInputSchema = exports.HopeKitImageInputSchema = exports.FileUploadCreateInputSchema = exports.FileUploadActionCompleteInputSchema = exports.ExchangePatchInputSchema = exports.EntityAccessLogRequestInputSchema = exports.EatingProgressEntryInputSchema = exports.EatingLogEntryPracticeImageUploadUrlInputSchema = exports.EatingLogEntryInputSchema = exports.EatingCommitmentEntryInputSchema = exports.EatingCheckinInputSchema = void 0;
exports.TestUserInputSchema = exports.TestRoleInputSchema = exports.TestPatientInputSchema = exports.StressBreathingRoundInputSchema = exports.StressBreathingExerciseInputSchema = exports.SnapshotSessionInputSchema = exports.SnapshotQuizSetCollectionInputSchema = exports.SleepDiaryEntryInputSchema = exports.SleepDiaryEntryInfluencerInputSchema = exports.RoleSettingsInputSchema = exports.RolePtsdConfigInputSchema = exports.RoleProductConfigInputSchema = exports.RolePractitionerInputSchema = exports.RoleAvivaConfigInputSchema = exports.ResumableAssetCreateInputSchema = exports.RemoveHopeKitItemInputSchema = exports.RelaxDiaryEntryInputSchema = exports.RegistrarInputSchema = exports.QuizSetUpdateInputSchema = exports.QuizSetItemVideoInputSchema = exports.QuizSetItemVideoCreateInputSchema = exports.QuizSetItemUpdateOrderInputSchema = exports.QuizSetItemDeleteInputSchema = exports.QuizSetItemChoiceUpdateInputSchema = exports.QuizSetItemChoiceOptionInputSchema = exports.QuizSetItemChoiceInputSchema = exports.QuizSetItemChoiceCreateInputSchema = exports.QuizSetInputSchema = exports.QuizSetDeleteInputSchema = exports.QuizSetCreateInputSchema = exports.QuizSetCollectionUpdateInputSchema = exports.QuizSetCollectionCreateInputSchema = exports.QueryUsersInputSchema = exports.PractitionerInputSchema = exports.PracticeValuesInputSchema = exports.PracticeRatingInputSchema = exports.PracticeContentInputSchema = exports.PersonWithEmailInputSchema = exports.PersonUpdateInputSchema = exports.PersonInputSchema = exports.PatientUpdateInputSchema = exports.PatientSupporterRelationInputSchema = exports.PatientSupporterInputSchema = exports.PatientInputSchema = exports.PatchInputSchema = exports.OrganizationYstConfigInputSchema = exports.OrganizationUpdateInputSchema = exports.OrganizationProductInputSchema = exports.OrganizationProductConfigInputSchema = exports.OrganizationMemberUpdateInputSchema = void 0;
exports.YstNominationUpdateInputSchema = exports.YstNominationRejectInputSchema = exports.YstNominationCreateInputSchema = exports.YSTPatientInputSchema = exports.WordPairingWidgetWordPairingsInputSchema = exports.WordPairingRoundInputSchema = exports.WordPairingInputSchema = exports.UserUsageSummaryInputSchema = exports.UserUsageInputSchema = exports.UserSettingsInputSchema = exports.UserRoleInputSchema = exports.UserNameInputSchema = exports.UserDemoInputSchema = exports.UserAddressInputSchema = exports.UserAccessLogRequestInputSchema = exports.UpdateUserInputSchema = exports.UpdateThoughtDiaryEntryPracticeInputSchema = exports.UpdateSleepDiaryEntryPracticeInputSchema = exports.UpdateSessionInputSchema = exports.UpdateRoleInputSchema = exports.UpdateRelaxDiaryEntryPracticeInputSchema = exports.UpdateOuiUserInputSchema = exports.UpdateHopeKitVideoInputSchema = exports.UpdateHopeKitQuoteInputSchema = exports.UpdateHopeKitImageInputSchema = exports.UpdateEatingLogEntryInputSchema = exports.UpdateActivityPracticeInputSchema = exports.ThoughtDiaryEntryInputSchema = exports.TextItemInputSchema = void 0;
const tslib_1 = require("tslib");
// This file is automatically generated. See gqlcodegen.yml for details
const CustomScalars = tslib_1.__importStar(require("./scalars"));
exports.ActionType = {
    ACTIVITY_ADD: 'ACTIVITY_ADD',
    ACTIVITY_RATE: 'ACTIVITY_RATE',
    BREATH_HOLDING: 'BREATH_HOLDING',
    COPING_CARD_ADD: 'COPING_CARD_ADD',
    COPING_CARD_REVIEW: 'COPING_CARD_REVIEW',
    EATING_LOG_ADD: 'EATING_LOG_ADD',
    HOPE_KIT_ADD: 'HOPE_KIT_ADD',
    HOPE_KIT_REVIEW: 'HOPE_KIT_REVIEW',
    HYPERVENTILATION: 'HYPERVENTILATION',
    MY_PLAN_REVIEW: 'MY_PLAN_REVIEW',
    RELAX: 'RELAX',
    SLEEP_DIARY_ENTRY_MORNING: 'SLEEP_DIARY_ENTRY_MORNING',
    SLEEP_DIARY_ENTRY_NIGHT: 'SLEEP_DIARY_ENTRY_NIGHT',
    STATIC_01: 'STATIC_01',
    STATIC_02: 'STATIC_02',
    STATIC_03: 'STATIC_03',
    STATIC_04: 'STATIC_04',
    STATIC_05: 'STATIC_05',
    STATIC_06: 'STATIC_06',
    STATIC_07: 'STATIC_07',
    STATIC_08: 'STATIC_08',
    STATIC_09: 'STATIC_09',
    STATIC_10: 'STATIC_10',
    STATIC_11: 'STATIC_11',
    STATIC_12: 'STATIC_12',
    THOUGHT_DIARY_SPOT: 'THOUGHT_DIARY_SPOT',
    THOUGHT_DIARY_SWITCH: 'THOUGHT_DIARY_SWITCH',
    THOUGHT_DIARY_TEST: 'THOUGHT_DIARY_TEST',
    WORD_PAIRING: 'WORD_PAIRING'
};
exports.AddressUse = {
    HOME: 'HOME',
    OLD: 'OLD',
    TEMP: 'TEMP',
    WORK: 'WORK'
};
exports.AppActivityName = {
    ACTIVITYDIARY: 'ActivityDiary',
    BINGEEATINGMYPLAN: 'BingeEatingMyPlan',
    BREATHHOLDING: 'BreathHolding',
    COPINGCARDS: 'CopingCards',
    CRISISFRAMEWORK: 'CrisisFramework',
    EATINGLOG: 'EatingLog',
    EDITEATINGSCHEDULE: 'EditEatingSchedule',
    HOPEKIT: 'HopeKit',
    HYPERVENTILATION: 'Hyperventilation',
    MYPLANREVIEW: 'MyPlanReview',
    RELAXATION: 'Relaxation',
    RISKCURVE: 'RiskCurve',
    SLEEPDIARY: 'SleepDiary',
    SOLOMYPLAN: 'SoloMyPlan',
    SOLORISKCURVE: 'SoloRiskCurve',
    SOLOSUICIDEMODE: 'SoloSuicideMode',
    STRESSSENSITIVITYASSESSMENT: 'StressSensitivityAssessment',
    SUICIDEMODE: 'SuicideMode',
    THOUGHTDIARY: 'ThoughtDiary',
    WORDPAIRING: 'WordPairing'
};
exports.CaringContactsMedium = {
    EMAIL: 'EMAIL',
    MAIL: 'MAIL',
    NONE: 'NONE',
    SMS: 'SMS'
};
exports.CompositionTemplate = {
    BINGE_EATING_MY_PLAN: 'BINGE_EATING_MY_PLAN',
    EATING_COMMITMENT: 'EATING_COMMITMENT',
    EATING_SCHEDULE: 'EATING_SCHEDULE',
    MYSTORYMYPLAN: 'MYSTORYMYPLAN',
    MYSTORYMYPLAN_CLINICAL: 'MYSTORYMYPLAN_CLINICAL',
    SCREENER_CSSRS: 'SCREENER_CSSRS',
    SCREENER_NUMERIC: 'SCREENER_NUMERIC',
    STRESS_SENSITIVITY_ASSESSMENT: 'STRESS_SENSITIVITY_ASSESSMENT',
    TEST: 'TEST',
    YST_MENTAL_HEALTH_CONCERNS: 'YST_MENTAL_HEALTH_CONCERNS'
};
exports.ContactPointSystem = {
    EMAIL: 'EMAIL',
    FAX: 'FAX',
    OTHER: 'OTHER',
    PAGER: 'PAGER',
    PHONE: 'PHONE',
    SMS: 'SMS',
    URL: 'URL'
};
exports.ContactPointUse = {
    HOME: 'HOME',
    MOBILE: 'MOBILE',
    OLD: 'OLD',
    TEMP: 'TEMP',
    WORK: 'WORK'
};
exports.ContentType = {
    ACTIVITY_PLANNING: 'ACTIVITY_PLANNING',
    ANXIETY_CAUSES: 'ANXIETY_CAUSES',
    BODY_IMAGE: 'BODY_IMAGE',
    BREATH_HOLDING: 'BREATH_HOLDING',
    COPING_CARDS: 'COPING_CARDS',
    EATING_THE_RIGHT_FOODS: 'EATING_THE_RIGHT_FOODS',
    ENVIRONMENT_SAFETY: 'ENVIRONMENT_SAFETY',
    EXERCISE_AND_SLEEP: 'EXERCISE_AND_SLEEP',
    HOPE_KIT: 'HOPE_KIT',
    HOW_TO_HELP: 'HOW_TO_HELP',
    HYPERVENTILATION: 'HYPERVENTILATION',
    MOOD_MODULATION: 'MOOD_MODULATION',
    MOOD_TOLERANCE: 'MOOD_TOLERANCE',
    MYPLAN: 'MYPLAN',
    MYPLAN_REVIEW: 'MYPLAN_REVIEW',
    MYSTORYMYPLAN: 'MYSTORYMYPLAN',
    OVEREATING_CYCLE: 'OVEREATING_CYCLE',
    POST_AVIVA: 'POST_AVIVA',
    REDUCE_RISK: 'REDUCE_RISK',
    REGULAR_EATING: 'REGULAR_EATING',
    RELAPSE_PREVENTION: 'RELAPSE_PREVENTION',
    RELAXATION: 'RELAXATION',
    REMOVING_BARRIERS: 'REMOVING_BARRIERS',
    REVIEW_PREVENT_PRACTICE: 'REVIEW_PREVENT_PRACTICE',
    SLEEP: 'SLEEP',
    SOCIAL_SUPPORT: 'SOCIAL_SUPPORT',
    SPOT_IT: 'SPOT_IT',
    STATIC_01: 'STATIC_01',
    STATIC_02: 'STATIC_02',
    STATIC_03: 'STATIC_03',
    STATIC_04: 'STATIC_04',
    STATIC_05: 'STATIC_05',
    STATIC_06: 'STATIC_06',
    STATIC_07: 'STATIC_07',
    STATIC_08: 'STATIC_08',
    STATIC_09: 'STATIC_09',
    STATIC_10: 'STATIC_10',
    STATIC_11: 'STATIC_11',
    STATIC_12: 'STATIC_12',
    SWITCH_IT: 'SWITCH_IT',
    TEST: 'TEST',
    TEST_IT: 'TEST_IT',
    THINK_CLEAR: 'THINK_CLEAR',
    URGE_SURFING: 'URGE_SURFING',
    V1_SESSION_01: 'V1_SESSION_01',
    V1_SESSION_02: 'V1_SESSION_02',
    V1_SESSION_03: 'V1_SESSION_03',
    V1_SESSION_04: 'V1_SESSION_04',
    V1_SESSION_05: 'V1_SESSION_05',
    V1_SESSION_06: 'V1_SESSION_06',
    V1_SESSION_06P: 'V1_SESSION_06P',
    V1_SESSION_07: 'V1_SESSION_07',
    V1_SESSION_07P: 'V1_SESSION_07P',
    V1_SESSION_08: 'V1_SESSION_08',
    V1_SESSION_08P: 'V1_SESSION_08P',
    V1_SESSION_09: 'V1_SESSION_09',
    V1_SESSION_09P: 'V1_SESSION_09P',
    V1_SESSION_10: 'V1_SESSION_10',
    V1_SESSION_10P: 'V1_SESSION_10P',
    V1_WELCOME: 'V1_WELCOME',
    WEIGHT_STIGMA: 'WEIGHT_STIGMA',
    WORD_PAIRING: 'WORD_PAIRING'
};
exports.CrisisFramework = {
    RISK_CURVE_TIMELINE: 'RISK_CURVE_TIMELINE',
    SUICIDE_MODE: 'SUICIDE_MODE'
};
exports.EatingCheckinCompletionButton = {
    DONE: 'DONE',
    SUGGESTION: 'SUGGESTION'
};
exports.EatingCheckinTrigger = {
    EATING_LOG: 'EATING_LOG',
    SESSION: 'SESSION'
};
exports.EatingCommitmentHealthyFood = {
    FRUITS: 'FRUITS',
    GRAINS: 'GRAINS',
    HEALTHY_FATS: 'HEALTHY_FATS',
    LEAN_MEATS: 'LEAN_MEATS',
    OTHER: 'OTHER',
    VEGETABLES: 'VEGETABLES'
};
exports.EatingCommitmentUnhealthyFood = {
    CANDY: 'CANDY',
    DESSERTS: 'DESSERTS',
    JUNK_FOOD: 'JUNK_FOOD',
    OTHER: 'OTHER',
    SODA: 'SODA',
    TAKEOUT: 'TAKEOUT'
};
exports.EatingLogMealType = {
    BREAKFAST: 'BREAKFAST',
    DINNER: 'DINNER',
    LUNCH: 'LUNCH',
    SNACK: 'SNACK'
};
exports.EatingProgressWeightUnit = {
    KG: 'KG',
    LBS: 'LBS'
};
exports.EntityType = {
    ORGANIZATION: 'ORGANIZATION',
    ORGANIZATION_PRODUCT: 'ORGANIZATION_PRODUCT',
    ROLE: 'ROLE',
    USER: 'USER'
};
exports.ErrorMessage = {
    CANCELED_REQUEST: 'CANCELED_REQUEST',
    DUPLICATE: 'DUPLICATE',
    EMAIL_IN_USE: 'EMAIL_IN_USE',
    INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
    INVALID_EMAIL: 'INVALID_EMAIL',
    NOT_FOUND: 'NOT_FOUND',
    UNAUTHORIZED: 'UNAUTHORIZED'
};
exports.ErrorStatus = {
    BAD_REQUEST: 'BAD_REQUEST',
    INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
    UNAUTHORIZED: 'UNAUTHORIZED'
};
exports.FileUploadType = {
    APP_LOGO: 'APP_LOGO',
    CHAT_IMAGE: 'CHAT_IMAGE',
    ILLUSTRATION: 'ILLUSTRATION',
    QUIZ_SET_VIDEO: 'QUIZ_SET_VIDEO',
    VIDEO: 'VIDEO',
    VIDEO_TEXT_TRACK: 'VIDEO_TEXT_TRACK'
};
exports.JobStatus = {
    CREATED: 'CREATED',
    ERROR: 'ERROR',
    QUEUED: 'QUEUED',
    RUNNING: 'RUNNING',
    SUCCESS: 'SUCCESS'
};
exports.JobType = {
    AMPLITUDE_IMPORT: 'AMPLITUDE_IMPORT',
    CHANGEBITE_NOTIFICATIONS: 'CHANGEBITE_NOTIFICATIONS',
    CHECK_EXPO_PUSH_RECEIPTS: 'CHECK_EXPO_PUSH_RECEIPTS',
    DETOX_USER_CLEANUP: 'DETOX_USER_CLEANUP',
    EMAIL_USERS: 'EMAIL_USERS',
    ENQUEUE_JOBS: 'ENQUEUE_JOBS',
    EXPIRED_USER_SESSION_CLEANUP: 'EXPIRED_USER_SESSION_CLEANUP',
    GROUP_SESSIONS: 'GROUP_SESSIONS',
    INVITE_YST_NOMINEE: 'INVITE_YST_NOMINEE',
    LOG: 'LOG',
    MEAL_REMINDER: 'MEAL_REMINDER',
    MY_PLAN_UPDATED_SUPPORTER_NOTIFICATION: 'MY_PLAN_UPDATED_SUPPORTER_NOTIFICATION',
    NORMALIZE_AMPLITUDE_EVENT_SESSION_START: 'NORMALIZE_AMPLITUDE_EVENT_SESSION_START',
    NORMALIZE_USERS_PHONE: 'NORMALIZE_USERS_PHONE',
    OTX202_DATA_EXPORT: 'OTX202_DATA_EXPORT',
    PATIENTS_PROGRESS_STARTED_AT_FOR_PRODUCT_STATIC_BACKFILL: 'PATIENTS_PROGRESS_STARTED_AT_FOR_PRODUCT_STATIC_BACKFILL',
    PATIENT_CARING_CONTACTS: 'PATIENT_CARING_CONTACTS',
    PATIENT_NOTIFICATIONS: 'PATIENT_NOTIFICATIONS',
    PATIENT_SPOOL: 'PATIENT_SPOOL',
    PROCESS_VIDEO_ASSET: 'PROCESS_VIDEO_ASSET',
    PTSD_NOTIFICATIONS: 'PTSD_NOTIFICATIONS',
    SEND_EMAIL: 'SEND_EMAIL',
    SLEEP: 'SLEEP',
    SYNC_GCS_MEDIA_UPLOAD: 'SYNC_GCS_MEDIA_UPLOAD',
    TEST_RECORD_CLEANUP: 'TEST_RECORD_CLEANUP',
    UNLOCK_SESSIONS: 'UNLOCK_SESSIONS',
    YST_NEW_SIGNUP_EMAIL: 'YST_NEW_SIGNUP_EMAIL',
    YST_NOMINATION_REMINDER: 'YST_NOMINATION_REMINDER',
    YST_REPORTS: 'YST_REPORTS',
    YST_SUPPORTER: 'YST_SUPPORTER'
};
exports.LegacyUserGender = {
    FEMALE: 'FEMALE',
    MALE: 'MALE',
    NOANSWER: 'NOANSWER',
    OTHER: 'OTHER'
};
exports.LegacyUserRace = {
    ASIAN: 'ASIAN',
    BLACK: 'BLACK',
    NATIVE: 'NATIVE',
    NOANSWER: 'NOANSWER',
    OTHER: 'OTHER',
    PACIFIC: 'PACIFIC',
    WHITE: 'WHITE'
};
exports.LegacyUserSexuality = {
    BISEXUAL: 'BISEXUAL',
    HETEROSEXUAL: 'HETEROSEXUAL',
    HOMOSEXUAL: 'HOMOSEXUAL',
    NOANSWER: 'NOANSWER'
};
exports.MediaAction = {
    FILE_UPLOAD_TO_GCS: 'FILE_UPLOAD_TO_GCS',
    MUX_HOSTING: 'MUX_HOSTING',
    REV_CAPTIONING: 'REV_CAPTIONING'
};
exports.MuxFitMode = {
    CROP: 'crop',
    PAD: 'pad',
    PRESERVE: 'preserve',
    SMARTCROP: 'smartcrop'
};
exports.OnboardingVariant = {
    COLLABORATIVE: 'COLLABORATIVE',
    INDEPENDENT: 'INDEPENDENT'
};
exports.OuiUserRoleType = {
    OUI_ADMIN: 'OUI_ADMIN',
    PATIENT: 'PATIENT',
    PRACTITIONER: 'PRACTITIONER',
    REGISTRAR: 'REGISTRAR',
    UNKNOWN: 'UNKNOWN'
};
exports.PatientGenderIdentity = {
    FEMALE: 'FEMALE',
    MALE: 'MALE',
    NON_BINARY: 'NON_BINARY',
    NON_DISCLOSE: 'NON_DISCLOSE',
    TRANSGENDER_FEMALE: 'TRANSGENDER_FEMALE',
    TRANSGENDER_MALE: 'TRANSGENDER_MALE',
    UNKNOWN: 'UNKNOWN'
};
exports.PatientMilitaryStatus = {
    ACTIVE_MILITARY_DUTY: 'ACTIVE_MILITARY_DUTY',
    CIVILIAN: 'CIVILIAN',
    DISABLED_VETERAN: 'DISABLED_VETERAN',
    FAMILY_MEMBER_OF_ACTIVE_DUTY: 'FAMILY_MEMBER_OF_ACTIVE_DUTY',
    FAMILY_MEMBER_OF_RETIRED_MILITARY: 'FAMILY_MEMBER_OF_RETIRED_MILITARY',
    INACTIVE_READY_RESERVE: 'INACTIVE_READY_RESERVE',
    NATIONAL_GUARD: 'NATIONAL_GUARD',
    NON_DISCLOSE: 'NON_DISCLOSE',
    RESERVES: 'RESERVES',
    RETIRED_MILITARY: 'RETIRED_MILITARY',
    UNKNOWN: 'UNKNOWN',
    VETERAN: 'VETERAN'
};
exports.PatientRace = {
    AMERICAN_INDIAN_OR_ALASKA_NATIVE: 'AMERICAN_INDIAN_OR_ALASKA_NATIVE',
    ASIAN: 'ASIAN',
    BLACK_OR_AFRICAN_AMERICAN: 'BLACK_OR_AFRICAN_AMERICAN',
    NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER: 'NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER',
    NON_DISCLOSE: 'NON_DISCLOSE',
    UNKNOWN: 'UNKNOWN',
    WHITE: 'WHITE'
};
exports.PatientSexualOrientation = {
    BISEXUAL: 'BISEXUAL',
    HETEROSEXUAL: 'HETEROSEXUAL',
    HOMOSEXUAL: 'HOMOSEXUAL',
    NON_DISCLOSE: 'NON_DISCLOSE',
    OTHER: 'OTHER',
    UNKNOWN: 'UNKNOWN'
};
exports.PatientSupporterRelation = {
    CLINICIAN: 'CLINICIAN',
    OTHER: 'OTHER',
    PARENT_GUARDIAN: 'PARENT_GUARDIAN',
    RELATIVE: 'RELATIVE',
    SOCIAL_SERVICES: 'SOCIAL_SERVICES'
};
exports.PracticeType = {
    ACTIVITY: 'ACTIVITY',
    BREATH_HOLDING: 'BREATH_HOLDING',
    EATING_CHECKIN: 'EATING_CHECKIN',
    EATING_COMMITMENT_ENTRY: 'EATING_COMMITMENT_ENTRY',
    EATING_LOG_ENTRY: 'EATING_LOG_ENTRY',
    EATING_PROGRESS_ENTRY: 'EATING_PROGRESS_ENTRY',
    HYPERVENTILATION: 'HYPERVENTILATION',
    RELAX_DIARY_ENTRY: 'RELAX_DIARY_ENTRY',
    SLEEP_DIARY_ENTRY: 'SLEEP_DIARY_ENTRY',
    THOUGHT_DIARY_ENTRY: 'THOUGHT_DIARY_ENTRY',
    WORD_PAIRING: 'WORD_PAIRING'
};
exports.ProductVariant = {
    AVIVA_ADOLESCENT: 'AVIVA_ADOLESCENT',
    AVIVA_ADULT: 'AVIVA_ADULT',
    AVIVA_INPATIENT: 'AVIVA_INPATIENT',
    AVIVA_MILITARY: 'AVIVA_MILITARY',
    AVIVA_STATIC: 'AVIVA_STATIC',
    AVIVA_SUPPORT: 'AVIVA_SUPPORT',
    OUI_PLATFORM: 'OUI_PLATFORM',
    YST_GUARDIAN: 'YST_GUARDIAN',
    YST_SUPPORT: 'YST_SUPPORT',
    YST_YOUTH: 'YST_YOUTH'
};
exports.ProductVersion = {
    AVIVA_1_1: 'AVIVA_1_1',
    AVIVA_2_0: 'AVIVA_2_0'
};
exports.PtsdDosageVersion = {
    V1: 'V1',
    V2: 'V2'
};
exports.QuizSetItemType = {
    MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
    SINGLE_CHOICE: 'SINGLE_CHOICE',
    VIDEO: 'VIDEO'
};
exports.RatingDuration = {
    ALL: 'ALL',
    DAY: 'DAY',
    MONTH: 'MONTH',
    WEEK: 'WEEK',
    YEAR: 'YEAR'
};
exports.RatingType = {
    QUALITY: 'QUALITY',
    RATING: 'RATING',
    RATING_AFTER: 'RATING_AFTER',
    RATING_BEFORE: 'RATING_BEFORE'
};
exports.RoleType = {
    GUARDIAN: 'GUARDIAN',
    PATIENT: 'PATIENT',
    PRACTITIONER: 'PRACTITIONER',
    REGISTRAR: 'REGISTRAR',
    SUPPORTER: 'SUPPORTER'
};
exports.SessionState = {
    COMPLETED: 'COMPLETED',
    IN_PROGRESS: 'IN_PROGRESS',
    LOCKED: 'LOCKED',
    UNLOCKED: 'UNLOCKED'
};
exports.SleepDiaryEntryDuration = {
    DURATION_1_TO_5: 'DURATION_1_TO_5',
    DURATION_5_TO_10: 'DURATION_5_TO_10',
    DURATION_15_TO_30: 'DURATION_15_TO_30',
    DURATION_20_TO_45: 'DURATION_20_TO_45',
    DURATION_30_TO_60: 'DURATION_30_TO_60',
    DURATION_45_TO_60: 'DURATION_45_TO_60',
    DURATION_60_TO_120: 'DURATION_60_TO_120',
    DURATION_120_TO_180: 'DURATION_120_TO_180',
    DURATION_LESS_THAN_15: 'DURATION_LESS_THAN_15',
    DURATION_MORE_THAN_60: 'DURATION_MORE_THAN_60',
    DURATION_MORE_THAN_120: 'DURATION_MORE_THAN_120',
    DURATION_MORE_THAN_180: 'DURATION_MORE_THAN_180'
};
exports.SleepDiaryEntryTimeOfDay = {
    AFTERNOON: 'AFTERNOON',
    EVENING: 'EVENING',
    MORNING: 'MORNING',
    NIGHT: 'NIGHT'
};
exports.UploadType = {
    AUDIO: 'AUDIO',
    IMAGE: 'IMAGE',
    VIDEO: 'VIDEO'
};
exports.UsageDuration = {
    DAY: 'DAY',
    MONTH: 'MONTH',
    WEEK: 'WEEK'
};
exports.UserGenderIdentity = {
    FEMALE: 'FEMALE',
    MALE: 'MALE',
    NON_BINARY: 'NON_BINARY',
    NON_DISCLOSE: 'NON_DISCLOSE',
    TRANSGENDER_FEMALE: 'TRANSGENDER_FEMALE',
    TRANSGENDER_MALE: 'TRANSGENDER_MALE',
    UNKNOWN: 'UNKNOWN'
};
exports.UserMilitaryStatus = {
    ACTIVE_MILITARY_DUTY: 'ACTIVE_MILITARY_DUTY',
    CIVILIAN: 'CIVILIAN',
    DISABLED_VETERAN: 'DISABLED_VETERAN',
    FAMILY_MEMBER_OF_ACTIVE_DUTY: 'FAMILY_MEMBER_OF_ACTIVE_DUTY',
    FAMILY_MEMBER_OF_RETIRED_MILITARY: 'FAMILY_MEMBER_OF_RETIRED_MILITARY',
    INACTIVE_READY_RESERVE: 'INACTIVE_READY_RESERVE',
    NATIONAL_GUARD: 'NATIONAL_GUARD',
    NON_DISCLOSE: 'NON_DISCLOSE',
    RESERVES: 'RESERVES',
    RETIRED_MILITARY: 'RETIRED_MILITARY',
    UNKNOWN: 'UNKNOWN',
    VETERAN: 'VETERAN'
};
exports.UserRace = {
    AMERICAN_INDIAN_OR_ALASKA_NATIVE: 'AMERICAN_INDIAN_OR_ALASKA_NATIVE',
    ASIAN: 'ASIAN',
    BLACK_OR_AFRICAN_AMERICAN: 'BLACK_OR_AFRICAN_AMERICAN',
    NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER: 'NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER',
    NON_DISCLOSE: 'NON_DISCLOSE',
    UNKNOWN: 'UNKNOWN',
    WHITE: 'WHITE'
};
exports.UserSexualOrientation = {
    BISEXUAL: 'BISEXUAL',
    HETEROSEXUAL: 'HETEROSEXUAL',
    HOMOSEXUAL: 'HOMOSEXUAL',
    NON_DISCLOSE: 'NON_DISCLOSE',
    OTHER: 'OTHER',
    UNKNOWN: 'UNKNOWN'
};
exports.YstNominationStatusValue = {
    ACCEPTED: 'ACCEPTED',
    APPROVED: 'APPROVED',
    DECLINED: 'DECLINED',
    INVITED: 'INVITED',
    INVITE_FAILED: 'INVITE_FAILED',
    INVITE_SCHEDULED: 'INVITE_SCHEDULED',
    PENDING_APPROVAL: 'PENDING_APPROVAL',
    REJECTED: 'REJECTED',
    SUGGESTED: 'SUGGESTED'
};
exports.YstPatientMessageValue = {
    ADMIN_CONTACT_RESPONSE: 'ADMIN_CONTACT_RESPONSE',
    CHECKIN_CALL_REMINDER: 'CHECKIN_CALL_REMINDER',
    CHECKIN_END: 'CHECKIN_END',
    CHECKIN_MIDDLE: 'CHECKIN_MIDDLE',
    CHECKIN_REMINDER: 'CHECKIN_REMINDER',
    CHECKIN_START: 'CHECKIN_START',
    GUARDIAN_INVITE: 'GUARDIAN_INVITE',
    INBOUND: 'INBOUND',
    NOMINATION: 'NOMINATION',
    NOMINATION_18PLUS: 'NOMINATION_18PLUS',
    NOMINATION_APPROVED: 'NOMINATION_APPROVED',
    NOMINATION_RESPONSE: 'NOMINATION_RESPONSE',
    NOMINATION_RESPONSE_WITHOUT_SUGGESTION: 'NOMINATION_RESPONSE_WITHOUT_SUGGESTION',
    NOMINATION_SUGGESTION_ACCEPTED: 'NOMINATION_SUGGESTION_ACCEPTED',
    ORIENTATION_REMINDER: 'ORIENTATION_REMINDER',
    RESOURCES_ACTIVATED: 'RESOURCES_ACTIVATED',
    SUPPORTER_ACCEPTED: 'SUPPORTER_ACCEPTED',
    SUPPORTER_CONFIRMATION: 'SUPPORTER_CONFIRMATION',
    SUPPORTER_DECLINED: 'SUPPORTER_DECLINED',
    SUPPORTER_GENERAL_RESOURCES_REMINDER: 'SUPPORTER_GENERAL_RESOURCES_REMINDER',
    SUPPORTER_INVITE: 'SUPPORTER_INVITE',
    SUPPORTER_INVITE_REMINDER: 'SUPPORTER_INVITE_REMINDER',
    YOUTH_INVITE: 'YOUTH_INVITE'
};
// @ts-ignore
const zod_1 = require("zod");
exports.AnySchema = zod_1.z.unknown();
exports.ArtifactIDSchema = zod_1.z.unknown();
exports.AssetIDSchema = zod_1.z.unknown();
exports.DateSchema = zod_1.z.string().regex(/^(\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01]))$/).transform(v => v);
exports.DateTimeSchema = zod_1.z.string().regex(/^(\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])T([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9]|60))(\.\d{1,})?(([Z])|([+|-]([01][0-9]|2[0-3]):[0-5][0-9]))$/);
exports.JSONObjectSchema = zod_1.z.unknown();
exports.MapSchema = zod_1.z.unknown();
exports.QuizSetItemQuestionDirectiveFeedbackSchema = zod_1.z.unknown();
exports.QuizSetItemQuestionLabelSchema = zod_1.z.unknown();
exports.UUIDSchema = zod_1.z.string({ required_error: 'Required' }).uuid({ message: 'Invalid value' }).transform((v) => v);
exports.UserIDSchema = zod_1.z.unknown();
exports.YstMentalHealthConcernsSchema = CustomScalars.YstMentalHealthConcerns;
exports.YstOnboardingAvailabilitySchema = CustomScalars.YstOnboardingAvailability;
exports.YstRecurringAvailabilitySchema = CustomScalars.YstRecurringAvailability;
exports.ActionTypeSchema = zod_1.z.enum(["ACTIVITY_ADD", "ACTIVITY_RATE", "BREATH_HOLDING", "COPING_CARD_ADD", "COPING_CARD_REVIEW", "EATING_LOG_ADD", "HOPE_KIT_ADD", "HOPE_KIT_REVIEW", "HYPERVENTILATION", "MY_PLAN_REVIEW", "RELAX", "SLEEP_DIARY_ENTRY_MORNING", "SLEEP_DIARY_ENTRY_NIGHT", "STATIC_01", "STATIC_02", "STATIC_03", "STATIC_04", "STATIC_05", "STATIC_06", "STATIC_07", "STATIC_08", "STATIC_09", "STATIC_10", "STATIC_11", "STATIC_12", "THOUGHT_DIARY_SPOT", "THOUGHT_DIARY_SWITCH", "THOUGHT_DIARY_TEST", "WORD_PAIRING"]);
exports.AddressUseSchema = zod_1.z.enum(["HOME", "OLD", "TEMP", "WORK"]);
exports.AppActivityNameSchema = zod_1.z.enum(["ActivityDiary", "BingeEatingMyPlan", "BreathHolding", "CopingCards", "CrisisFramework", "EatingLog", "EditEatingSchedule", "HopeKit", "Hyperventilation", "MyPlanReview", "Relaxation", "RiskCurve", "SleepDiary", "SoloMyPlan", "SoloRiskCurve", "SoloSuicideMode", "StressSensitivityAssessment", "SuicideMode", "ThoughtDiary", "WordPairing"]);
exports.CaringContactsMediumSchema = zod_1.z.enum(["EMAIL", "MAIL", "NONE", "SMS"]);
exports.CompositionTemplateSchema = zod_1.z.enum(["BINGE_EATING_MY_PLAN", "EATING_COMMITMENT", "EATING_SCHEDULE", "MYSTORYMYPLAN", "MYSTORYMYPLAN_CLINICAL", "SCREENER_CSSRS", "SCREENER_NUMERIC", "STRESS_SENSITIVITY_ASSESSMENT", "TEST", "YST_MENTAL_HEALTH_CONCERNS"]);
exports.ContactPointSystemSchema = zod_1.z.enum(["EMAIL", "FAX", "OTHER", "PAGER", "PHONE", "SMS", "URL"]);
exports.ContactPointUseSchema = zod_1.z.enum(["HOME", "MOBILE", "OLD", "TEMP", "WORK"]);
exports.ContentTypeSchema = zod_1.z.enum(["ACTIVITY_PLANNING", "ANXIETY_CAUSES", "BODY_IMAGE", "BREATH_HOLDING", "COPING_CARDS", "EATING_THE_RIGHT_FOODS", "ENVIRONMENT_SAFETY", "EXERCISE_AND_SLEEP", "HOPE_KIT", "HOW_TO_HELP", "HYPERVENTILATION", "MOOD_MODULATION", "MOOD_TOLERANCE", "MYPLAN", "MYPLAN_REVIEW", "MYSTORYMYPLAN", "OVEREATING_CYCLE", "POST_AVIVA", "REDUCE_RISK", "REGULAR_EATING", "RELAPSE_PREVENTION", "RELAXATION", "REMOVING_BARRIERS", "REVIEW_PREVENT_PRACTICE", "SLEEP", "SOCIAL_SUPPORT", "SPOT_IT", "STATIC_01", "STATIC_02", "STATIC_03", "STATIC_04", "STATIC_05", "STATIC_06", "STATIC_07", "STATIC_08", "STATIC_09", "STATIC_10", "STATIC_11", "STATIC_12", "SWITCH_IT", "TEST", "TEST_IT", "THINK_CLEAR", "URGE_SURFING", "V1_SESSION_01", "V1_SESSION_02", "V1_SESSION_03", "V1_SESSION_04", "V1_SESSION_05", "V1_SESSION_06", "V1_SESSION_06P", "V1_SESSION_07", "V1_SESSION_07P", "V1_SESSION_08", "V1_SESSION_08P", "V1_SESSION_09", "V1_SESSION_09P", "V1_SESSION_10", "V1_SESSION_10P", "V1_WELCOME", "WEIGHT_STIGMA", "WORD_PAIRING"]);
exports.CrisisFrameworkSchema = zod_1.z.enum(["RISK_CURVE_TIMELINE", "SUICIDE_MODE"]);
exports.EatingCheckinCompletionButtonSchema = zod_1.z.enum(["DONE", "SUGGESTION"]);
exports.EatingCheckinTriggerSchema = zod_1.z.enum(["EATING_LOG", "SESSION"]);
exports.EatingCommitmentHealthyFoodSchema = zod_1.z.enum(["FRUITS", "GRAINS", "HEALTHY_FATS", "LEAN_MEATS", "OTHER", "VEGETABLES"]);
exports.EatingCommitmentUnhealthyFoodSchema = zod_1.z.enum(["CANDY", "DESSERTS", "JUNK_FOOD", "OTHER", "SODA", "TAKEOUT"]);
exports.EatingLogMealTypeSchema = zod_1.z.enum(["BREAKFAST", "DINNER", "LUNCH", "SNACK"]);
exports.EatingProgressWeightUnitSchema = zod_1.z.enum(["KG", "LBS"]);
exports.EntityTypeSchema = zod_1.z.enum(["ORGANIZATION", "ORGANIZATION_PRODUCT", "ROLE", "USER"]);
exports.ErrorMessageSchema = zod_1.z.enum(["CANCELED_REQUEST", "DUPLICATE", "EMAIL_IN_USE", "INTERNAL_SERVER_ERROR", "INVALID_EMAIL", "NOT_FOUND", "UNAUTHORIZED"]);
exports.ErrorStatusSchema = zod_1.z.enum(["BAD_REQUEST", "INTERNAL_SERVER_ERROR", "UNAUTHORIZED"]);
exports.FileUploadTypeSchema = zod_1.z.enum(["APP_LOGO", "CHAT_IMAGE", "ILLUSTRATION", "QUIZ_SET_VIDEO", "VIDEO", "VIDEO_TEXT_TRACK"]);
exports.JobStatusSchema = zod_1.z.enum(["CREATED", "ERROR", "QUEUED", "RUNNING", "SUCCESS"]);
exports.JobTypeSchema = zod_1.z.enum(["AMPLITUDE_IMPORT", "CHANGEBITE_NOTIFICATIONS", "CHECK_EXPO_PUSH_RECEIPTS", "DETOX_USER_CLEANUP", "EMAIL_USERS", "ENQUEUE_JOBS", "EXPIRED_USER_SESSION_CLEANUP", "GROUP_SESSIONS", "INVITE_YST_NOMINEE", "LOG", "MEAL_REMINDER", "MY_PLAN_UPDATED_SUPPORTER_NOTIFICATION", "NORMALIZE_AMPLITUDE_EVENT_SESSION_START", "NORMALIZE_USERS_PHONE", "OTX202_DATA_EXPORT", "PATIENTS_PROGRESS_STARTED_AT_FOR_PRODUCT_STATIC_BACKFILL", "PATIENT_CARING_CONTACTS", "PATIENT_NOTIFICATIONS", "PATIENT_SPOOL", "PROCESS_VIDEO_ASSET", "PTSD_NOTIFICATIONS", "SEND_EMAIL", "SLEEP", "SYNC_GCS_MEDIA_UPLOAD", "TEST_RECORD_CLEANUP", "UNLOCK_SESSIONS", "YST_NEW_SIGNUP_EMAIL", "YST_NOMINATION_REMINDER", "YST_REPORTS", "YST_SUPPORTER"]);
exports.LegacyUserGenderSchema = zod_1.z.enum(["FEMALE", "MALE", "NOANSWER", "OTHER"]);
exports.LegacyUserRaceSchema = zod_1.z.enum(["ASIAN", "BLACK", "NATIVE", "NOANSWER", "OTHER", "PACIFIC", "WHITE"]);
exports.LegacyUserSexualitySchema = zod_1.z.enum(["BISEXUAL", "HETEROSEXUAL", "HOMOSEXUAL", "NOANSWER"]);
exports.MediaActionSchema = zod_1.z.enum(["FILE_UPLOAD_TO_GCS", "MUX_HOSTING", "REV_CAPTIONING"]);
exports.MuxFitModeSchema = zod_1.z.enum(["crop", "pad", "preserve", "smartcrop"]);
exports.OnboardingVariantSchema = zod_1.z.enum(["COLLABORATIVE", "INDEPENDENT"]);
exports.OuiUserRoleTypeSchema = zod_1.z.enum(["OUI_ADMIN", "PATIENT", "PRACTITIONER", "REGISTRAR", "UNKNOWN"]);
exports.PatientGenderIdentitySchema = zod_1.z.enum(["FEMALE", "MALE", "NON_BINARY", "NON_DISCLOSE", "TRANSGENDER_FEMALE", "TRANSGENDER_MALE", "UNKNOWN"]);
exports.PatientMilitaryStatusSchema = zod_1.z.enum(["ACTIVE_MILITARY_DUTY", "CIVILIAN", "DISABLED_VETERAN", "FAMILY_MEMBER_OF_ACTIVE_DUTY", "FAMILY_MEMBER_OF_RETIRED_MILITARY", "INACTIVE_READY_RESERVE", "NATIONAL_GUARD", "NON_DISCLOSE", "RESERVES", "RETIRED_MILITARY", "UNKNOWN", "VETERAN"]);
exports.PatientRaceSchema = zod_1.z.enum(["AMERICAN_INDIAN_OR_ALASKA_NATIVE", "ASIAN", "BLACK_OR_AFRICAN_AMERICAN", "NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER", "NON_DISCLOSE", "UNKNOWN", "WHITE"]);
exports.PatientSexualOrientationSchema = zod_1.z.enum(["BISEXUAL", "HETEROSEXUAL", "HOMOSEXUAL", "NON_DISCLOSE", "OTHER", "UNKNOWN"]);
exports.PatientSupporterRelationSchema = zod_1.z.enum(["CLINICIAN", "OTHER", "PARENT_GUARDIAN", "RELATIVE", "SOCIAL_SERVICES"]);
exports.PracticeTypeSchema = zod_1.z.enum(["ACTIVITY", "BREATH_HOLDING", "EATING_CHECKIN", "EATING_COMMITMENT_ENTRY", "EATING_LOG_ENTRY", "EATING_PROGRESS_ENTRY", "HYPERVENTILATION", "RELAX_DIARY_ENTRY", "SLEEP_DIARY_ENTRY", "THOUGHT_DIARY_ENTRY", "WORD_PAIRING"]);
exports.ProductVariantSchema = zod_1.z.enum(["AVIVA_ADOLESCENT", "AVIVA_ADULT", "AVIVA_INPATIENT", "AVIVA_MILITARY", "AVIVA_STATIC", "AVIVA_SUPPORT", "OUI_PLATFORM", "YST_GUARDIAN", "YST_SUPPORT", "YST_YOUTH"]);
exports.ProductVersionSchema = zod_1.z.enum(["AVIVA_1_1", "AVIVA_2_0"]);
exports.PtsdDosageVersionSchema = zod_1.z.enum(["V1", "V2"]);
exports.QuizSetItemTypeSchema = zod_1.z.enum(["MULTIPLE_CHOICE", "SINGLE_CHOICE", "VIDEO"]);
exports.RatingDurationSchema = zod_1.z.enum(["ALL", "DAY", "MONTH", "WEEK", "YEAR"]);
exports.RatingTypeSchema = zod_1.z.enum(["QUALITY", "RATING", "RATING_AFTER", "RATING_BEFORE"]);
exports.RoleTypeSchema = zod_1.z.enum(["GUARDIAN", "PATIENT", "PRACTITIONER", "REGISTRAR", "SUPPORTER"]);
exports.SessionStateSchema = zod_1.z.enum(["COMPLETED", "IN_PROGRESS", "LOCKED", "UNLOCKED"]);
exports.SleepDiaryEntryDurationSchema = zod_1.z.enum(["DURATION_1_TO_5", "DURATION_5_TO_10", "DURATION_15_TO_30", "DURATION_20_TO_45", "DURATION_30_TO_60", "DURATION_45_TO_60", "DURATION_60_TO_120", "DURATION_120_TO_180", "DURATION_LESS_THAN_15", "DURATION_MORE_THAN_60", "DURATION_MORE_THAN_120", "DURATION_MORE_THAN_180"]);
exports.SleepDiaryEntryTimeOfDaySchema = zod_1.z.enum(["AFTERNOON", "EVENING", "MORNING", "NIGHT"]);
exports.UploadTypeSchema = zod_1.z.enum(["AUDIO", "IMAGE", "VIDEO"]);
exports.UsageDurationSchema = zod_1.z.enum(["DAY", "MONTH", "WEEK"]);
exports.UserGenderIdentitySchema = zod_1.z.enum(["FEMALE", "MALE", "NON_BINARY", "NON_DISCLOSE", "TRANSGENDER_FEMALE", "TRANSGENDER_MALE", "UNKNOWN"]);
exports.UserMilitaryStatusSchema = zod_1.z.enum(["ACTIVE_MILITARY_DUTY", "CIVILIAN", "DISABLED_VETERAN", "FAMILY_MEMBER_OF_ACTIVE_DUTY", "FAMILY_MEMBER_OF_RETIRED_MILITARY", "INACTIVE_READY_RESERVE", "NATIONAL_GUARD", "NON_DISCLOSE", "RESERVES", "RETIRED_MILITARY", "UNKNOWN", "VETERAN"]);
exports.UserRaceSchema = zod_1.z.enum(["AMERICAN_INDIAN_OR_ALASKA_NATIVE", "ASIAN", "BLACK_OR_AFRICAN_AMERICAN", "NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER", "NON_DISCLOSE", "UNKNOWN", "WHITE"]);
exports.UserSexualOrientationSchema = zod_1.z.enum(["BISEXUAL", "HETEROSEXUAL", "HOMOSEXUAL", "NON_DISCLOSE", "OTHER", "UNKNOWN"]);
exports.YstNominationStatusValueSchema = zod_1.z.enum(["ACCEPTED", "APPROVED", "DECLINED", "INVITED", "INVITE_FAILED", "INVITE_SCHEDULED", "PENDING_APPROVAL", "REJECTED", "SUGGESTED"]);
exports.YstPatientMessageValueSchema = zod_1.z.enum(["ADMIN_CONTACT_RESPONSE", "CHECKIN_CALL_REMINDER", "CHECKIN_END", "CHECKIN_MIDDLE", "CHECKIN_REMINDER", "CHECKIN_START", "GUARDIAN_INVITE", "INBOUND", "NOMINATION", "NOMINATION_18PLUS", "NOMINATION_APPROVED", "NOMINATION_RESPONSE", "NOMINATION_RESPONSE_WITHOUT_SUGGESTION", "NOMINATION_SUGGESTION_ACCEPTED", "ORIENTATION_REMINDER", "RESOURCES_ACTIVATED", "SUPPORTER_ACCEPTED", "SUPPORTER_CONFIRMATION", "SUPPORTER_DECLINED", "SUPPORTER_GENERAL_RESOURCES_REMINDER", "SUPPORTER_INVITE", "SUPPORTER_INVITE_REMINDER", "YOUTH_INVITE"]);
exports.ActionValuesInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    patientID: exports.UUIDSchema
}));
exports.ActivityInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    attendee: zod_1.z.string().nullish(),
    endTime: exports.DateTimeSchema,
    location: zod_1.z.string().nullish(),
    notes: zod_1.z.string().nullish(),
    startTime: exports.DateTimeSchema,
    title: zod_1.z.string()
}));
exports.AddActionInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    actionType: exports.ActionTypeSchema,
    actionValues: exports.ActionValuesInputSchema,
    practiceID: exports.UUIDSchema.nullish()
}));
exports.AddActivityPracticeInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    activity: exports.ActivityInputSchema,
    practiceValues: exports.PracticeValuesInputSchema
}));
exports.AddEatingLogEntryInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    eatingLogEntry: exports.EatingLogEntryInputSchema,
    practiceValues: exports.PracticeValuesInputSchema
}));
exports.AddHopeKitImageInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    hopeKitImage: exports.HopeKitImageInputSchema,
    uploadContentType: zod_1.z.string()
}));
exports.AddHopeKitQuoteInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    hopeKitQuote: exports.HopeKitQuoteInputSchema
}));
exports.AddHopeKitVideoInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    hopeKitVideo: exports.HopeKitVideoInputSchema,
    uploadContentType: zod_1.z.string()
}));
exports.AddRelaxDiaryEntryPracticeInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    practiceValues: exports.PracticeValuesInputSchema,
    relaxDiaryEntry: exports.RelaxDiaryEntryInputSchema
}));
exports.AddSleepDiaryEntryPracticeInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    practiceValues: exports.PracticeValuesInputSchema,
    sleepDiaryEntry: exports.SleepDiaryEntryInputSchema
}));
exports.AddThoughtDiaryEntryPracticeInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    practiceValues: exports.PracticeValuesInputSchema,
    thoughtDiaryEntry: exports.ThoughtDiaryEntryInputSchema
}));
exports.AddressInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    city: zod_1.z.string().nullish(),
    line: zod_1.z.array(zod_1.z.string()).nullish(),
    postalCode: zod_1.z.string().nullish(),
    rank: zod_1.z.number(),
    state: zod_1.z.string().nullish(),
    use: exports.AddressUseSchema
}));
exports.BreathHoldingWidgetStressBreathingExercisesInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    after: exports.DateSchema.nullish(),
    before: exports.DateSchema.nullish(),
    limit: zod_1.z.number().nullish()
}));
exports.CMSAppCreateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    logoID: exports.UUIDSchema,
    name: zod_1.z.string()
}));
exports.CMSAppUpdateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    appID: exports.UUIDSchema,
    logoID: exports.UUIDSchema.nullish(),
    name: zod_1.z.string().nullish()
}));
exports.CMSSessionCreateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    agenda: zod_1.z.array(zod_1.z.string()).nullish(),
    completedIllustrationID: exports.UUIDSchema.nullish(),
    content: exports.JSONObjectSchema.nullish(),
    contentType: zod_1.z.string(),
    description: zod_1.z.string(),
    groupID: exports.UUIDSchema,
    illustrationID: exports.UUIDSchema.nullish(),
    locale: zod_1.z.string(),
    name: zod_1.z.string(),
    order: zod_1.z.number(),
    variantID: exports.UUIDSchema
}));
exports.CMSSessionGroupCreateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    name: zod_1.z.string(),
    order: zod_1.z.number().nullish(),
    variantID: exports.UUIDSchema
}));
exports.CMSSessionGroupUpdateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    groupID: exports.UUIDSchema,
    name: zod_1.z.string(),
    order: zod_1.z.number()
}));
exports.CMSVariantCreateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    appID: exports.UUIDSchema,
    name: zod_1.z.string(),
    version: zod_1.z.string()
}));
exports.CMSVariantUpdateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    appID: exports.UUIDSchema.nullish(),
    name: zod_1.z.string().nullish(),
    variantID: exports.UUIDSchema,
    version: zod_1.z.string().nullish()
}));
exports.ChangeBiteRoleSettingsInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    sessionUnlockDayOfWeek: zod_1.z.number().nullish()
}));
exports.CompleteQuizSetForPatientInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    patientID: exports.UUIDSchema,
    quizSetID: zod_1.z.string(),
    slug: zod_1.z.string()
}));
exports.CompletedQuizSetsForPatientInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    patientID: exports.UUIDSchema,
    slug: zod_1.z.string()
}));
exports.ContactPointInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    rank: zod_1.z.number(),
    system: exports.ContactPointSystemSchema,
    use: exports.ContactPointUseSchema,
    value: zod_1.z.string()
}));
exports.CopyQuizSetToCollectionInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    quizSetCollectionID: exports.UUIDSchema,
    quizSetID: exports.UUIDSchema
}));
exports.CopySessionInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    destination: exports.CopySessionInputDestinationSchema,
    sessionID: exports.UUIDSchema
}));
exports.CopySessionInputDestinationSchema = zod_1.z.lazy(() => zod_1.z.object({
    groupID: exports.UUIDSchema,
    variantID: exports.UUIDSchema
}));
exports.CreateRoleInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    organizationID: exports.UUIDSchema,
    practitioners: zod_1.z.array(exports.RolePractitionerInputSchema).nullish(),
    productConfig: exports.RoleProductConfigInputSchema.nullish(),
    productID: exports.UUIDSchema,
    productStatic: zod_1.z.boolean(),
    roleType: exports.RoleTypeSchema,
    supporteeID: exports.UUIDSchema.nullish(),
    supporteeRelation: exports.PatientSupporterRelationSchema.nullish()
}));
exports.CreateUserInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    addresses: zod_1.z.array(exports.AddressInputSchema).nullish(),
    birthDate: exports.DateSchema.nullish(),
    email: zod_1.z.string().email(),
    familyName: zod_1.z.string().nullish(),
    genderIdentity: exports.UserGenderIdentitySchema.nullish(),
    givenName: zod_1.z.string().nullish(),
    locale: zod_1.z.string().nullish(),
    militaryStatus: exports.UserMilitaryStatusSchema.nullish(),
    phone: zod_1.z.string().nullish(),
    race: exports.UserRaceSchema.nullish(),
    settings: exports.UserSettingsInputSchema.nullish(),
    sexualOrientation: exports.UserSexualOrientationSchema.nullish(),
    timezone: zod_1.z.string().nullish()
}));
exports.DeleteSessionGroupInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    groupID: exports.UUIDSchema
}));
exports.DeleteSessionInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    sessionID: exports.UUIDSchema
}));
exports.DeviceInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    expoToken: zod_1.z.string().nullish(),
    installationID: exports.UUIDSchema,
    platform: zod_1.z.string(),
    pushToken: zod_1.z.string().nullish()
}));
exports.EatingCheckinInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    completionButtonClicked: exports.EatingCheckinCompletionButtonSchema.nullish(),
    completionTimestamp: exports.DateTimeSchema.nullish(),
    mood: zod_1.z.number().nullish(),
    promptTimestamp: exports.DateTimeSchema,
    trigger: exports.EatingCheckinTriggerSchema,
    urgeLevel: zod_1.z.number().nullish()
}));
exports.EatingCommitmentEntryInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    decreaseCommitment: exports.EatingCommitmentUnhealthyFoodSchema,
    decreaseSuccess: zod_1.z.boolean().nullish(),
    increaseCommitment: exports.EatingCommitmentHealthyFoodSchema,
    increaseSuccess: zod_1.z.boolean().nullish()
}));
exports.EatingLogEntryInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    binged: zod_1.z.boolean(),
    description: zod_1.z.string().nullish(),
    meal: exports.EatingLogMealTypeSchema,
    timestamp: exports.DateTimeSchema
}));
exports.EatingLogEntryPracticeImageUploadUrlInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    contentType: zod_1.z.string()
}));
exports.EatingProgressEntryInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    binges: zod_1.z.number().nullish(),
    fadFixes: zod_1.z.number().nullish(),
    timestamp: exports.DateTimeSchema,
    weight: zod_1.z.number().nullish(),
    weightUnit: exports.EatingProgressWeightUnitSchema.nullish()
}));
exports.EntityAccessLogRequestInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    entityID: exports.UUIDSchema,
    entityType: exports.EntityTypeSchema
}));
exports.ExchangePatchInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    exchangeID: exports.UUIDSchema,
    patches: zod_1.z.array(exports.PatchInputSchema)
}));
exports.FileUploadActionCompleteInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    fileUploadId: exports.UUIDSchema,
    mediaAction: exports.MediaActionSchema
}));
exports.FileUploadCreateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    fileName: zod_1.z.string(),
    fileUploadType: exports.FileUploadTypeSchema
}));
exports.HopeKitImageInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    reason: zod_1.z.string().nullish()
}));
exports.HopeKitQuoteInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    author: zod_1.z.string().nullish(),
    reason: zod_1.z.string().nullish(),
    text: zod_1.z.string()
}));
exports.HopeKitVideoInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    reason: zod_1.z.string().nullish()
}));
exports.HyperventilationWidgetStressBreathingExercisesInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    after: exports.DateSchema.nullish(),
    before: exports.DateSchema.nullish(),
    limit: zod_1.z.number().nullish()
}));
exports.LatLngInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    lat: zod_1.z.number(),
    lng: zod_1.z.number()
}));
exports.MutationAddBreathHoldingPracticeInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    practiceValues: exports.PracticeValuesInputSchema,
    stressBreathingExercise: exports.StressBreathingExerciseInputSchema
}));
exports.MutationAddEatingCheckinInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    eatingCheckin: exports.EatingCheckinInputSchema,
    practiceValues: exports.PracticeValuesInputSchema
}));
exports.MutationAddEatingProgressEntryInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    eatingProgressEntry: exports.EatingProgressEntryInputSchema,
    practiceValues: exports.PracticeValuesInputSchema
}));
exports.MutationAddHyperventilationPracticeInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    practiceValues: exports.PracticeValuesInputSchema,
    stressBreathingExercise: exports.StressBreathingExerciseInputSchema
}));
exports.MutationAddWordPairingPracticeInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    practiceValues: exports.PracticeValuesInputSchema,
    wordPairing: exports.WordPairingInputSchema
}));
exports.MutationAddYstSupporterEventInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    patientID: exports.UUIDSchema,
    status: zod_1.z.string(),
    type: zod_1.z.string(),
    value: zod_1.z.string(),
    youthID: exports.UUIDSchema
}));
exports.MutationContactYstSupportInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    body: zod_1.z.string(),
    primaryClinician: zod_1.z.boolean().nullish()
}));
exports.MutationCreateJobInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    payload: exports.JSONObjectSchema,
    synchronous: zod_1.z.boolean().nullish(),
    type: exports.JobTypeSchema
}));
exports.MutationCreateTestScenarioInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    organization: exports.OrganizationInputSchema,
    users: zod_1.z.array(exports.TestUserInputSchema)
}));
exports.MutationCreateUserInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    roles: zod_1.z.array(exports.CreateRoleInputSchema),
    user: exports.CreateUserInputSchema
}));
exports.MutationCreateVideoInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    fileUploadID: exports.UUIDSchema
}));
exports.MutationDeclineYstNominationInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    reason: zod_1.z.string()
}));
exports.MutationInviteYSTGuardianInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    guardian: exports.YSTPatientInputSchema,
    youthID: exports.UUIDSchema
}));
exports.MutationInviteYSTYouthInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    youth: exports.YSTPatientInputSchema
}));
exports.MutationNominateYstSupportersInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    create: zod_1.z.array(exports.YstNominationCreateInputSchema).nullish(),
    reject: zod_1.z.array(exports.YstNominationRejectInputSchema).nullish(),
    update: zod_1.z.array(exports.YstNominationUpdateInputSchema).nullish(),
    youthID: exports.UUIDSchema
}));
exports.MutationPersistBotStateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    configID: zod_1.z.string(),
    envelopes: zod_1.z.array(exports.MapSchema),
    previousBotStateID: exports.UUIDSchema.nullish(),
    state: zod_1.z.string()
}));
exports.MutationPreviewYstPatientMessageInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    ystPatientMessageID: exports.UUIDSchema
}));
exports.MutationRateYstSupporterCheckinInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    rating: zod_1.z.number().int().max(6).min(1),
    ystSupporterCheckinID: exports.UUIDSchema
}));
exports.MutationResendYstPatientMessageInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    ystPatientMessageID: exports.UUIDSchema
}));
exports.MutationSignupYSTGuardianInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    organizationID: exports.UUIDSchema,
    password: zod_1.z.string().min(8),
    patient: exports.YSTPatientInputSchema
}));
exports.MutationSignupYSTYouthInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    organizationID: exports.UUIDSchema,
    password: zod_1.z.string().min(8),
    patient: exports.YSTPatientInputSchema
}));
exports.MutationUpdateBreathHoldingPracticeInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    practiceID: exports.UUIDSchema,
    practiceValues: exports.PracticeValuesInputSchema,
    stressBreathingExercise: exports.StressBreathingExerciseInputSchema
}));
exports.MutationUpdateEatingCheckinInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    eatingCheckin: exports.EatingCheckinInputSchema,
    practiceID: exports.UUIDSchema,
    practiceValues: exports.PracticeValuesInputSchema
}));
exports.MutationUpdateEatingProgressEntryInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    eatingProgressEntry: exports.EatingProgressEntryInputSchema,
    practiceID: exports.UUIDSchema,
    practiceValues: exports.PracticeValuesInputSchema
}));
exports.MutationUpdateFirstCheckinDateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    date: exports.DateSchema,
    patientID: exports.UUIDSchema
}));
exports.MutationUpdateHyperventilationPracticeInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    practiceID: exports.UUIDSchema,
    practiceValues: exports.PracticeValuesInputSchema,
    stressBreathingExercise: exports.StressBreathingExerciseInputSchema
}));
exports.MutationUpdateOnboardingAvailabilityInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    onboardingAvailability: exports.YstOnboardingAvailabilitySchema
}));
exports.MutationUpdatePracticeInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    content: exports.PracticeContentInputSchema.nullish(),
    date: exports.DateSchema.nullish(),
    practiceID: exports.UUIDSchema,
    ratings: zod_1.z.array(exports.PracticeRatingInputSchema).nullish()
}));
exports.MutationUpdateRecurringAvailabilityInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    patientID: exports.UUIDSchema.nullish(),
    recurringAvailability: exports.YstRecurringAvailabilitySchema
}));
exports.MutationUpdateRoleSettingsInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    roleID: exports.UUIDSchema,
    settings: exports.RoleSettingsInputSchema
}));
exports.MutationUpdateUserInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    roles: zod_1.z.array(exports.UserRoleInputSchema).nullish(),
    user: exports.UpdateUserInputSchema.nullish(),
    userID: exports.UUIDSchema
}));
exports.MutationUpdateWordPairingPracticeInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    practiceID: exports.UUIDSchema,
    practiceValues: exports.PracticeValuesInputSchema,
    wordPairing: exports.WordPairingInputSchema
}));
exports.MutationUpdateYstMentalHealthConcernsInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    patientID: exports.UUIDSchema,
    ystMentalHealthConcerns: exports.YstMentalHealthConcernsSchema
}));
exports.MutationUpdateYstSupporterEventInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    status: zod_1.z.string(),
    type: zod_1.z.string(),
    value: zod_1.z.string(),
    ystSupporterEventID: exports.UUIDSchema
}));
exports.OrganizationAvivaConfigInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    caringContactsEnabled: zod_1.z.boolean(),
    crisisFramework: exports.CrisisFrameworkSchema,
    onboardingVariant: exports.OnboardingVariantSchema,
    productVersion: exports.ProductVersionSchema
}).merge(zod_1.z.object({ "caringContactsEnabled": zod_1.z.boolean(), "crisisFramework": zod_1.z.enum(["SUICIDE_MODE", "RISK_CURVE_TIMELINE"]), "onboardingVariant": zod_1.z.enum(["COLLABORATIVE", "INDEPENDENT"]), "productVersion": zod_1.z.enum(["AVIVA_1_1", "AVIVA_2_0"]) })));
exports.OrganizationInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    isTrialOrganization: zod_1.z.boolean().nullish(),
    name: zod_1.z.string(),
    parent: exports.UUIDSchema.nullish(),
    products: zod_1.z.array(exports.OrganizationProductInputSchema).nullish()
}));
exports.OrganizationMemberUpdateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    person: exports.PersonUpdateInputSchema.nullish(),
    roles: zod_1.z.array(exports.OuiUserRoleTypeSchema)
}));
exports.OrganizationProductConfigInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    avivaConfig: exports.OrganizationAvivaConfigInputSchema.nullish(),
    ystConfig: exports.OrganizationYstConfigInputSchema.nullish()
}));
exports.OrganizationProductInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    name: zod_1.z.string().nullish(),
    nameStatic: zod_1.z.string().nullish(),
    productConfig: exports.OrganizationProductConfigInputSchema.nullish(),
    productID: exports.UUIDSchema
}));
exports.OrganizationUpdateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    isTrialOrganization: zod_1.z.boolean().nullish(),
    name: zod_1.z.string().nullish(),
    products: zod_1.z.array(exports.OrganizationProductInputSchema).nullish()
}));
exports.OrganizationYstConfigInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    contacts: zod_1.z.array(zod_1.z.string()),
    slug: zod_1.z.string(),
    unlisted: zod_1.z.boolean().nullish()
}).merge(zod_1.z.object({ "slug": zod_1.z.string().regex(new RegExp("^[\\w-]+$"), "Can only contain letters and dashes"), "contacts": zod_1.z.array(zod_1.z.string().email()).min(1, "At least one contact email must be provided"), "unlisted": zod_1.z.boolean().default(false) })));
exports.PatchInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    inverse: exports.JSONObjectSchema,
    payload: exports.JSONObjectSchema
}));
exports.PatientInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    caringContactsMedium: exports.CaringContactsMediumSchema.nullish(),
    onboardingVariant: exports.OnboardingVariantSchema.nullish(),
    person: exports.PersonInputSchema,
    productID: exports.UUIDSchema.nullish(),
    productStatic: zod_1.z.boolean().nullish(),
    productVersion: exports.ProductVersionSchema.nullish(),
    roleType: exports.RoleTypeSchema.nullish()
}));
exports.PatientSupporterInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    person: exports.PersonInputSchema,
    productStatic: zod_1.z.boolean().nullish(),
    productVariant: exports.ProductVariantSchema.nullish(),
    relation: exports.PatientSupporterRelationSchema
}));
exports.PatientSupporterRelationInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    patientID: exports.UUIDSchema,
    relation: exports.PatientSupporterRelationSchema
}));
exports.PatientUpdateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    caringContactsMedium: exports.CaringContactsMediumSchema.nullish(),
    person: exports.PersonUpdateInputSchema.nullish()
}));
exports.PersonInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    birthDate: exports.DateSchema.nullish(),
    email: zod_1.z.string().email().nullish(),
    familyName: zod_1.z.string(),
    genderIdentity: exports.UserGenderIdentitySchema.nullish(),
    givenName: zod_1.z.string(),
    militaryStatus: exports.UserMilitaryStatusSchema.nullish(),
    phone: zod_1.z.string().nullish(),
    race: exports.UserRaceSchema.nullish(),
    settings: exports.UserSettingsInputSchema.nullish(),
    sexualOrientation: exports.UserSexualOrientationSchema.nullish()
}));
exports.PersonUpdateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    birthDate: exports.DateSchema.nullish(),
    contactPoint: zod_1.z.array(exports.ContactPointInputSchema).nullish(),
    email: zod_1.z.string().email().nullish(),
    familyName: zod_1.z.string().nullish(),
    genderIdentity: exports.UserGenderIdentitySchema.nullish(),
    givenName: zod_1.z.string().nullish(),
    militaryStatus: exports.UserMilitaryStatusSchema.nullish(),
    phone: zod_1.z.string().nullish(),
    race: exports.UserRaceSchema.nullish(),
    settings: exports.UserSettingsInputSchema.nullish(),
    sexualOrientation: exports.UserSexualOrientationSchema.nullish()
}));
exports.PersonWithEmailInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    birthDate: exports.DateSchema.nullish(),
    email: zod_1.z.string().email(),
    familyName: zod_1.z.string(),
    genderIdentity: exports.UserGenderIdentitySchema.nullish(),
    givenName: zod_1.z.string(),
    militaryStatus: exports.UserMilitaryStatusSchema.nullish(),
    phone: zod_1.z.string().nullish(),
    race: exports.UserRaceSchema.nullish(),
    settings: exports.UserSettingsInputSchema.nullish(),
    sexualOrientation: exports.UserSexualOrientationSchema.nullish()
}));
exports.PracticeContentInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    eatingCommitmentEntry: exports.EatingCommitmentEntryInputSchema.nullish()
}));
exports.PracticeRatingInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    type: exports.RatingTypeSchema,
    value: zod_1.z.number()
}));
exports.PracticeValuesInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    date: exports.DateSchema.nullish(),
    patientID: exports.UUIDSchema,
    ratings: zod_1.z.array(exports.PracticeRatingInputSchema)
}));
exports.PractitionerInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    npi: zod_1.z.number().nullish(),
    person: exports.PersonInputSchema
}));
exports.QueryUsersInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    organizationID: exports.UUIDSchema.nullish(),
    primaryPractitionerIDs: zod_1.z.array(exports.UUIDSchema).nullish(),
    productID: exports.UUIDSchema.nullish(),
    query: zod_1.z.string().nullish(),
    roleTypes: zod_1.z.array(exports.RoleTypeSchema).nullish(),
    sessions: zod_1.z.array(exports.ContentTypeSchema).nullish()
}));
exports.QuizSetCollectionCreateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    name: zod_1.z.string(),
    nodeID: exports.UUIDSchema,
    quizSetCollectionID: exports.UUIDSchema,
    sessionID: exports.UUIDSchema
}));
exports.QuizSetCollectionUpdateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    name: zod_1.z.string(),
    quizSetCollectionID: zod_1.z.string()
}));
exports.QuizSetCreateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    quizSet: exports.QuizSetInputSchema,
    quizSetCollectionID: exports.UUIDSchema
}));
exports.QuizSetDeleteInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    quizSetID: exports.UUIDSchema
}));
exports.QuizSetInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    description: zod_1.z.string(),
    name: zod_1.z.string()
}));
exports.QuizSetItemChoiceCreateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    quizSetID: exports.UUIDSchema,
    quizSetItemChoice: exports.QuizSetItemChoiceInputSchema
}));
exports.QuizSetItemChoiceInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    afterAllFeedback: zod_1.z.string(),
    correctFeedback: zod_1.z.string(),
    incorrectFeedback: zod_1.z.string(),
    options: zod_1.z.array(exports.QuizSetItemChoiceOptionInputSchema),
    prompt: zod_1.z.string(),
    type: exports.QuizSetItemTypeSchema
}));
exports.QuizSetItemChoiceOptionInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    correct: zod_1.z.boolean(),
    feedback: zod_1.z.string(),
    text: zod_1.z.string(),
    value: zod_1.z.string()
}));
exports.QuizSetItemChoiceUpdateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    quizSetItemChoice: exports.QuizSetItemChoiceInputSchema,
    quizSetItemID: exports.UUIDSchema
}));
exports.QuizSetItemDeleteInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    quizSetItemID: exports.UUIDSchema
}));
exports.QuizSetItemUpdateOrderInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    order: zod_1.z.number(),
    quizSetItemID: exports.UUIDSchema
}));
exports.QuizSetItemVideoCreateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    quizSetID: exports.UUIDSchema,
    quizSetItemVideo: exports.QuizSetItemVideoInputSchema
}));
exports.QuizSetItemVideoInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    fileUploadID: zod_1.z.string()
}));
exports.QuizSetUpdateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    quizSet: exports.QuizSetInputSchema,
    quizSetID: exports.UUIDSchema
}));
exports.RegistrarInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    person: exports.PersonInputSchema
}));
exports.RelaxDiaryEntryInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    completion: zod_1.z.number(),
    slug: zod_1.z.string()
}));
exports.RemoveHopeKitItemInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    hopeKitItemID: exports.UUIDSchema
}));
exports.ResumableAssetCreateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    context: zod_1.z.string(),
    fileName: zod_1.z.string(),
    key: zod_1.z.string(),
    uploadType: exports.UploadTypeSchema
}));
exports.RoleAvivaConfigInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    caringContactsMedium: exports.CaringContactsMediumSchema,
    crisisFramework: exports.CrisisFrameworkSchema,
    onboardingVariant: exports.OnboardingVariantSchema,
    productVersion: exports.ProductVersionSchema
}));
exports.RolePractitionerInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    practitionerID: exports.UUIDSchema,
    primaryPractitioner: zod_1.z.boolean()
}));
exports.RoleProductConfigInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    avivaConfig: exports.RoleAvivaConfigInputSchema.nullish(),
    ptsdConfig: exports.RolePtsdConfigInputSchema.nullish()
}));
exports.RolePtsdConfigInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    dosageVersion: exports.PtsdDosageVersionSchema
}));
exports.RoleSettingsInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    changeBiteSettings: exports.ChangeBiteRoleSettingsInputSchema.nullish()
}));
exports.SleepDiaryEntryInfluencerInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    count: zod_1.z.number().nullish(),
    duration: exports.SleepDiaryEntryDurationSchema.nullish(),
    kinds: zod_1.z.array(zod_1.z.string()).nullish(),
    occurred: zod_1.z.boolean(),
    timesOfDay: zod_1.z.array(exports.SleepDiaryEntryTimeOfDaySchema)
}));
exports.SleepDiaryEntryInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    alcohol: exports.SleepDiaryEntryInfluencerInputSchema.nullish(),
    caffeine: exports.SleepDiaryEntryInfluencerInputSchema.nullish(),
    deviceInBed: exports.SleepDiaryEntryInfluencerInputSchema.nullish(),
    endTime: exports.DateTimeSchema,
    exercise: exports.SleepDiaryEntryInfluencerInputSchema.nullish(),
    medicine: exports.SleepDiaryEntryInfluencerInputSchema.nullish(),
    napping: exports.SleepDiaryEntryInfluencerInputSchema.nullish(),
    sleepDelay: exports.SleepDiaryEntryDurationSchema.nullish(),
    startTime: exports.DateTimeSchema,
    tobacco: exports.SleepDiaryEntryInfluencerInputSchema.nullish(),
    wakeupCount: zod_1.z.number(),
    wakeupDuration: exports.SleepDiaryEntryDurationSchema.nullish()
}));
exports.SnapshotQuizSetCollectionInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    quizSetCollectionID: exports.UUIDSchema
}));
exports.SnapshotSessionInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    sessionID: exports.UUIDSchema
}));
exports.StressBreathingExerciseInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    rounds: zod_1.z.array(exports.StressBreathingRoundInputSchema)
}));
exports.StressBreathingRoundInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    distressRating: zod_1.z.number().max(10).min(1).nullish()
}));
exports.TestPatientInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    caringContactsMedium: exports.CaringContactsMediumSchema.nullish(),
    crisisFramework: exports.CrisisFrameworkSchema.nullish(),
    onboardingVariant: exports.OnboardingVariantSchema.nullish(),
    productSlug: zod_1.z.string().nullish(),
    productStatic: zod_1.z.boolean().nullish(),
    productVersion: exports.ProductVersionSchema.nullish(),
    roleType: exports.RoleTypeSchema.nullish()
}));
exports.TestRoleInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    practitionerEmails: zod_1.z.array(zod_1.z.string()).nullish(),
    productConfig: exports.RoleProductConfigInputSchema.nullish(),
    productID: exports.UUIDSchema,
    productStatic: zod_1.z.boolean(),
    roleType: exports.RoleTypeSchema,
    supporteeEmail: zod_1.z.string().nullish(),
    ystNominationStatus: zod_1.z.string().nullish()
}));
exports.TestUserInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    password: zod_1.z.string().nullish(),
    roles: zod_1.z.array(exports.TestRoleInputSchema),
    user: exports.CreateUserInputSchema
}));
exports.TextItemInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    ID: exports.UUIDSchema,
    text: zod_1.z.string()
}));
exports.ThoughtDiaryEntryInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    behavior: zod_1.z.string(),
    event: zod_1.z.string(),
    evidenceAgainst: zod_1.z.array(exports.TextItemInputSchema),
    evidenceFor: zod_1.z.array(exports.TextItemInputSchema),
    feelingsAfter: zod_1.z.array(exports.TextItemInputSchema),
    feelingsBefore: zod_1.z.array(exports.TextItemInputSchema),
    thoughtAfter: zod_1.z.string(),
    thoughtBefore: zod_1.z.string()
}));
exports.UpdateActivityPracticeInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    activity: exports.ActivityInputSchema,
    practiceID: exports.UUIDSchema,
    practiceValues: exports.PracticeValuesInputSchema
}));
exports.UpdateEatingLogEntryInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    deleteImage: zod_1.z.boolean().nullish(),
    eatingLogEntry: exports.EatingLogEntryInputSchema,
    practiceID: exports.UUIDSchema,
    practiceValues: exports.PracticeValuesInputSchema
}));
exports.UpdateHopeKitImageInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    hopeKitItemID: exports.UUIDSchema,
    reason: zod_1.z.string().nullish()
}));
exports.UpdateHopeKitQuoteInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    author: zod_1.z.string().nullish(),
    hopeKitItemID: exports.UUIDSchema,
    reason: zod_1.z.string().nullish(),
    text: zod_1.z.string()
}));
exports.UpdateHopeKitVideoInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    hopeKitItemID: exports.UUIDSchema,
    reason: zod_1.z.string().nullish()
}));
exports.UpdateOuiUserInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    currentPassword: zod_1.z.string().nullish(),
    email: zod_1.z.string().nullish(),
    password: zod_1.z.string().nullish(),
    person: exports.PersonUpdateInputSchema.nullish()
}));
exports.UpdateRelaxDiaryEntryPracticeInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    practiceID: exports.UUIDSchema,
    practiceValues: exports.PracticeValuesInputSchema,
    relaxDiaryEntry: exports.RelaxDiaryEntryInputSchema
}));
exports.UpdateRoleInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    organizationID: exports.UUIDSchema.nullish(),
    practitioners: zod_1.z.array(exports.RolePractitionerInputSchema).nullish(),
    productConfig: exports.RoleProductConfigInputSchema.nullish(),
    productID: exports.UUIDSchema.nullish(),
    productStatic: zod_1.z.boolean().nullish(),
    roleID: exports.UUIDSchema,
    roleType: exports.RoleTypeSchema.nullish(),
    supporteeID: exports.UUIDSchema.nullish(),
    supporteeRelation: exports.PatientSupporterRelationSchema.nullish()
}));
exports.UpdateSessionInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    agenda: zod_1.z.array(zod_1.z.string()).nullish(),
    completedIllustrationID: exports.UUIDSchema.nullish(),
    contentType: zod_1.z.string().nullish(),
    description: zod_1.z.string().nullish(),
    groupID: exports.UUIDSchema,
    illustrationID: exports.UUIDSchema.nullish(),
    locale: zod_1.z.string().nullish(),
    name: zod_1.z.string().nullish(),
    order: zod_1.z.number().nullish(),
    sessionID: exports.UUIDSchema,
    statusID: zod_1.z.number().nullish(),
    variantID: exports.UUIDSchema
}));
exports.UpdateSleepDiaryEntryPracticeInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    practiceID: exports.UUIDSchema,
    practiceValues: exports.PracticeValuesInputSchema,
    sleepDiaryEntry: exports.SleepDiaryEntryInputSchema
}));
exports.UpdateThoughtDiaryEntryPracticeInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    practiceID: exports.UUIDSchema,
    practiceValues: exports.PracticeValuesInputSchema,
    thoughtDiaryEntry: exports.ThoughtDiaryEntryInputSchema
}));
exports.UpdateUserInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    addresses: zod_1.z.array(exports.AddressInputSchema).nullish(),
    birthDate: exports.DateSchema.nullish(),
    email: zod_1.z.string().email().nullish(),
    familyName: zod_1.z.string().nullish(),
    genderIdentity: exports.UserGenderIdentitySchema.nullish(),
    givenName: zod_1.z.string().nullish(),
    locale: zod_1.z.string().nullish(),
    militaryStatus: exports.UserMilitaryStatusSchema.nullish(),
    phone: zod_1.z.string().nullish(),
    race: exports.UserRaceSchema.nullish(),
    settings: exports.UserSettingsInputSchema.nullish(),
    sexualOrientation: exports.UserSexualOrientationSchema.nullish(),
    timezone: zod_1.z.string().nullish()
}));
exports.UserAccessLogRequestInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    userID: exports.UUIDSchema
}));
exports.UserAddressInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    city: zod_1.z.string(),
    country: zod_1.z.string(),
    line1: zod_1.z.string(),
    line2: zod_1.z.string(),
    state: zod_1.z.string().nullish(),
    zip: zod_1.z.string().nullish()
}));
exports.UserDemoInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    DOB: exports.DateSchema.nullish(),
    gender: exports.LegacyUserGenderSchema.nullish(),
    isVeteran: zod_1.z.boolean().nullish(),
    race: exports.LegacyUserRaceSchema.nullish(),
    sexuality: exports.LegacyUserSexualitySchema.nullish()
}));
exports.UserNameInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    first: zod_1.z.string(),
    last: zod_1.z.string(),
    pfx: zod_1.z.string().nullish(),
    preferred: zod_1.z.string().nullish(),
    sfx: zod_1.z.string().nullish()
}));
exports.UserRoleInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    createRole: exports.CreateRoleInputSchema.nullish(),
    updateRole: exports.UpdateRoleInputSchema.nullish()
}));
exports.UserSettingsInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    emailPreferred: zod_1.z.boolean().nullish(),
    phonePreferred: zod_1.z.boolean().nullish()
}));
exports.UserUsageInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    after: exports.DateSchema.nullish(),
    before: exports.DateSchema.nullish(),
    duration: exports.UsageDurationSchema,
    productSlug: zod_1.z.string().nullish(),
    roleID: exports.UUIDSchema.nullish()
}));
exports.UserUsageSummaryInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    after: exports.DateSchema.nullish(),
    before: exports.DateSchema.nullish(),
    productSlug: zod_1.z.string().nullish(),
    roleID: exports.UUIDSchema.nullish()
}));
exports.WordPairingInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    rounds: zod_1.z.array(exports.WordPairingRoundInputSchema)
}));
exports.WordPairingRoundInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    numAnswers: zod_1.z.number().max(40).nonnegative(),
    numCorrectAnswers: zod_1.z.number().max(40).nonnegative(),
    time: zod_1.z.number().nonnegative()
}));
exports.WordPairingWidgetWordPairingsInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    after: exports.DateSchema.nullish(),
    before: exports.DateSchema.nullish(),
    limit: zod_1.z.number().nullish()
}));
exports.YSTPatientInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    birthDate: exports.DateSchema.nullish(),
    person: exports.PersonWithEmailInputSchema
}));
exports.YstNominationCreateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    email: zod_1.z.string().email().nullish(),
    familyName: zod_1.z.string(),
    givenName: zod_1.z.string(),
    phone: zod_1.z.string().nullish(),
    relation: zod_1.z.string()
}));
exports.YstNominationRejectInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    reason: zod_1.z.string(),
    ystNominationID: zod_1.z.string()
}));
exports.YstNominationUpdateInputSchema = zod_1.z.lazy(() => zod_1.z.object({
    email: zod_1.z.string().nullish(),
    familyName: zod_1.z.string().nullish(),
    givenName: zod_1.z.string().nullish(),
    phone: zod_1.z.string().nullish(),
    ystNominationID: zod_1.z.string()
}));
//# sourceMappingURL=graphql.generated.js.map